import { Box, CircularProgress } from '@mui/material'

import styles from './styles.module.scss'

const Loader = () => {
  return (
    <Box className={`${styles.loader} sub-container`}>
      <CircularProgress />
    </Box>
  )
}

export default Loader
